// // CambioServicePage.tsx

// import { PermissionsEnum } from "@/auth/interfaces";

import { MRT_ColumnDef } from "material-react-table";
import { cellNotFilter } from "@/shared";
import { useMemo } from "react";
import {
  GeneralTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel'
import EditIcon from '@mui/icons-material/Edit';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import { exportarExcelCambios } from "../../utils/exportarExcelCambios";
import { getCambios, getMisCambios, useFetchGetTiposMetrica } from "@/shared/actions";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useNavigate } from 'react-router-dom';
import { Grid, Tooltip, IconButton, Typography, Box, Button } from "@mui/material";
import { useState } from "react";
import { ResumenCambioCards} from "../../components";



import { useFetchCambios, useFetchMisCambios} from '@/shared/actions';
import { Cambio } from "../../types";


//
import { urlBackend } from '@/shared/constants';

///
import {
  useFetchPatchCambioEstado, useFetchCancelarCambio,
} from '@/shared/actions/controlcambios/cambio-service.actions';
import {  MetricaCumplimientoRequest } from "../../types";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  FormControl,
   Radio, RadioGroup, FormControlLabel, TextField
} from "@mui/material";
import ModalReprogramarCambio from "../../components/modal-reprogramar/ModalReprogramarCambio";
//
import { HistorialCambioModal } from "../../components";
import HistoryIcon from "@mui/icons-material/History";
//
import { useUiConfirmModalStore } from "@/store/ui";
import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";
import { toFilterParams } from "@/erp/controlcambios/servidores";

type CambiosPageProps = {
  soloMios?: boolean;
};

export const CambiosPage = ({ soloMios = false }: CambiosPageProps) => {
  const user = useAuthStore((s) => s.user) as any; 
  const userModules = useUserModulesStore((s) => s.modules);  
  const isSuper = !!user?.is_superuser || !!user?.is_staff; 
  const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_CAMBIOS) 
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore((s) => s.setConfirmDialogIsOpen);
  const origen = soloMios ? "mis" : "todos";
  const origenUrl = soloMios
    ? ROUTER_PATHS.control_cambios.misCambiosNav
    : ROUTER_PATHS.control_cambios.cambioServicenav;
  const navigate = useNavigate();
   ///* table
  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;
  const filtros = toFilterParams(columnFilters, { codigo: "exact" });
  // Según la pestaña: "Mis cambios" usa el endpoint del usuario; "Todos" el general.
  // Se llaman ambos hooks (rules-of-hooks) pero solo uno queda habilitado.
  const todosQuery = useFetchCambios(
    { page: pageIndex, size: pageSize, ...filtros },
    !soloMios
  );
  const miosQuery = useFetchMisCambios(
    { page: pageIndex, size: pageSize, ...filtros },
    soloMios
  );
  const {
    data: response,
    isLoading,
    isRefetching,
  } = soloMios ? miosQuery : todosQuery;
  ///TIPOACIONES
  const {data:tipometricas} = useFetchGetTiposMetrica({
    estado: true,
  })
  const returnObservacionUrl = ROUTER_PATHS.control_cambios.cambioServicenav;
  const [] = useState(0);

  const [estadoDialogOpen, setEstadoDialogOpen] = useState(false);
  const [cambioSeleccionado, setCambioSeleccionado] = useState<Cambio | null>(null);
  const [] = useState('');

//   const PREGUNTAS_METRICAS = [
//   '¿Hubo rollback?',
//   '¿Se restableció el servicio correctamente?',
//   '¿Se notificó a los usuarios?',
// ];
const [metricas, setMetricas] = useState<MetricaCumplimientoRequest[]>([]);

const [reprogCambio, setReprogCambio] = useState<Cambio | null>(null);
const [historialCambio, setHistorialCambio] = useState<Cambio | null>(null);


const patchEstadoMutation = useFetchPatchCambioEstado();
const cancelarMutation = useFetchCancelarCambio();
const abrirEstadoDialog = (cambio: Cambio) => {
const estadoActual = cambio.estado?.toUpperCase();
  setCambioSeleccionado(cambio);

  if (estadoActual === 'APROBADO') {
    // Avanzar directo a EN_EJECUCION (sin métricas)
    patchEstadoMutation.mutate({
      id: cambio.id,
      data: { estado: 'EN_EJECUCION' },
    });
    return;
  }

  if (estadoActual === 'EN_EJECUCION') {
    // Abrir modal de métricas → IMPLEMENTADO
    setMetricas(
      // PREGUNTAS_METRICAS.map(d => ({ descripcion: d, cumplido: false, observacion: '' }))
      (tipometricas?.data ?? []).map(d => ({ descripcion: d.nombre, cumplido: false, observacion: '' }))
    );
    setEstadoDialogOpen(true);
  }
};
const confirmarCambioEstado = () => {
  if (!cambioSeleccionado) return;
  patchEstadoMutation.mutate({
    id: cambioSeleccionado.id,
    data: { estado: 'IMPLEMENTADO', metricas },
  });
  setEstadoDialogOpen(false);
};

  // const handleBuscar = (filtros: any) => {
  //   console.log("Filtros enviados a la API:", filtros);
  // };

const handleExportarExcel = async () => {
  const res = soloMios
    ? await getMisCambios({ page: 0, size: 10000 })
    : await getCambios({ page: 0, size: 10000 });
  exportarExcelCambios(res?.data ?? [], soloMios ? "mis-cambios" : "control-de-cambios");
};

  const counts = {
    total: response?.totalElements ?? 0,
    pendientes: response?.data?.filter(c => c.estado === 'Pendiente' || c.estado === 'PENDIENTE').length ?? 0,
    aprobados: response?.data?.filter(c => c.estado === 'Aprobado' || c.estado === 'APROBADO').length ?? 0,
    rechazado: response?.data?.filter(c => c.estado === 'Rechazado' || c.estado === 'RECHAZADO').length ?? 0,
    implementado: response?.data?.filter(c => c.estado === 'Implementado' || c.estado === 'IMPLEMENTADO').length ?? 0,
    // rechazado: response?.data?.filter(c => c.estado === 'Rechazado' || c.estado === 'RECHAZADO').length ?? 0,
  };

  const columns = useMemo<MRT_ColumnDef<Cambio>[]>(
    () => [
       {
        accessorKey: "codigo",
        header: "Codigo de identificacion",
        size: 180,
        Cell: ({ row }) => (
          <Typography variant="body2" fontWeight="600" color="#3b82f6">
            {row.original?.codigo || "N/A"}
          </Typography>
        ),
      },
      {
        accessorKey: "titulo",
        header: "Titulo",
        size: 180,
        Cell: ({ row }) => row.original?.titulo || 'N/A',
      },
      {
        accessorKey: "usuarioCreacion",
        header: "Usuario del proceso a cargo",
        size: 180,
        Cell: ({ row }) => row.original?.usuarioCreacion || 'N/A',
      },
      {
        accessorKey: "descripcion",
        header: "Descripcion",
        size: 180,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "240px",
            }}
            title={row.original?.descripcion} // Tooltip nativo al pasar el mouse
          >
            {row.original?.descripcion || "N/A"}
          </Typography>
        ),
      },

     {
        accessorKey: "prioridad",
        header: "PRIORIDAD",
        size: 130,
        Cell: ({ row }) => {
          const prioridad = row.original?.prioridad?.toUpperCase() || "";
          let dotColor = "#9e9e9e"; // Gris por defecto

          if (prioridad.includes("CRIT") || prioridad.includes("ALT")) {
            dotColor = "#d32f2f"; // Rojo vibrante para alarmas
          } else if (prioridad.includes("MED")) {
            dotColor = "#ed6c02"; // Naranja
          } else if (prioridad.includes("BAJ")) {
            dotColor = "#0288d1"; // Azul
          }

          return row.original?.prioridad ? (
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box 
                sx={{ 
                  width: 7, 
                  height: 7, 
                  borderRadius: "50%", 
                  bgcolor: dotColor,
                  boxShadow: `0 0 6px ${dotColor}aa` // Un sutil resplandor en el punto
                }} 
              />
              <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.85rem" }}>
                {prioridad}
              </Typography>
            </Box>
          ) : "N/A";
        },
      },
      {
        accessorKey: "estado",
        header: "Estado",
        size: 130,
        Cell: ({ row }) => {
          const estado = row.original?.estado?.toLowerCase() || "";
          let bgSubtle = "#f5f5f5";
          let textColor = "#616161";
          let textoAMostrar = row.original.estado;
          if (estado.includes("pend")) { bgSubtle = "#fff3e0"; textColor = "#b26a00"; }
          else if (estado.includes("aprob") || estado.includes("resuel")) { bgSubtle = "#e8f5e9"; textColor = "#2e7d32"; }
          else if (estado.includes("rechaz") || estado.includes("cancel")) { bgSubtle = "#ffebee"; textColor = "#c62828"; }
          else if (estado.includes("imple")) {
            // Mapeo visual de IMPLEMENTADO a FINALIZADO
            bgSubtle = "#e8f5e9"; 
            textColor = "#2e7d32";
            textoAMostrar = "FINALIZADO";
          }
          return row.original?.estado ? (
            <Box 
              sx={{ 
                display: 'inline-flex',
                px: 1.5, 
                py: 0.4, 
                borderRadius: '6px', 
                bgcolor: bgSubtle, 
                color: textColor,
                fontSize: '0.75rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              {/* {row.original.estado} */}
              {textoAMostrar}

            </Box>
          ) : "N/A";
        },
      },
      {
        accessorKey: "riesgo",
        header: "RIESGO",
        size: 110,
        Cell: ({ row }) => (
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {row.original?.riesgo?.toUpperCase() || "N/A"}
          </Typography>
        ),
      },

      {
        accessorKey: "fechaCreacion",
        header: "Fecha de creación",
        size: 180,
        filterVariant: "date-range",
        Cell: ({ row }) => new Date(row.original?.fechaCreacion).toLocaleString() || 'N/A',
      },
      {
        accessorKey: "fechaActualizacion",
        header: "Fecha de actualización",
        filterVariant: "date-range",
        size: 180,
        Cell: ({ row }) => new Date(row.original?.fechaActualizacion).toLocaleDateString('es-EC',{
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        } ) || 'N/A',
      },
      {
        ...cellNotFilter,
        accessorKey: "fechaActualizacion",
        header: "Fecha de ejecución",
        // filterVariant: "date-range",
        size: 180,
        Cell: ({ row }) => {const fechaEjecucion = row.original.fechaEjecucion
          if(fechaEjecucion==null || fechaEjecucion  ===""){
            return "N/A"
          }
          return new Date(fechaEjecucion).toLocaleString()

        },
      },
    ],[]
  )

  if(!isSuper || !tineAccesoAreacontrolAreas){

  return (

    <SingleTableBoxScene
      title={soloMios ? "Mis cambios" : "Control de cambios"}
      py={2}
      visibleReport={true}
      // urlRedirect={`${ROUTER_PATHS.control_cambios.cambioServicenav}/crear`}
      urlRedirect={`${ROUTER_PATHS.control_cambios.cambioServicenav}/crear?origen=${origen}`}
      enableRedirect={true}
      customContentButtonSide={
        <Button
          variant="outlined"
          color="success"
          startIcon={<FileDownloadIcon />}
          onClick={handleExportarExcel}
        >
          Exportar Excel
        </Button>
      }
    >
      
      <ResumenCambioCards
        total={counts.total}
        pendientes={counts.pendientes}
        aprobados={counts.aprobados}
        rechazado={counts.rechazado}
        implementado={counts.implementado}
      />





      <GeneralTable<Cambio>
        columns={columns}
        data={response?.data|| []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        //enableSorting={false}
        // // filters - llega al back
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={response?.totalElements ?? 0}
        // // actions ========
        // enableColumnActions={hasPermission(PermissionsEnum.api_change_observacion)}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_BIG}
        positionActionsColumn="first"
        canEdit={false}

        showCustomActionBtnSpace={true}
        customActionBtnSpace={(value) => {
          const cambio = value as Cambio;

          return (
            <Grid container spacing={0.5} wrap="nowrap">
            {
              
              //{/* 1. Ver información completa */}
               <Grid item >
                  <Tooltip title={'Ver información completa'} placement="top">
                    <IconButton
                    color="info"
                     onClick={() =>
                    navigate(`${ROUTER_PATHS.control_cambios.cambioServicenav}/ver/${cambio.id}`, {
                      state: { from: origenUrl },
                    })
                  }

                    >
                      <VisibilityIcon  fontSize="small"/>
                    </IconButton>
                  </Tooltip>
                </Grid>
            }

            {/* Historial */}
              <Grid item>
                <Tooltip title="Ver historial" placement="top">
                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() => setHistorialCambio(cambio)}
                  >
                    <HistoryIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Grid>
              {/* 2. Editar*/}
               { <Grid item >
                  <Tooltip
                    title={
                      cambio.estado?.toUpperCase() === 'IMPLEMENTADO'
                        ? 'No se puede editar un cambio implementado'
                        : 'Editar cambio'
                    }
                    placement="top"
                  >
                    <span>
                      <IconButton
                        color="warning"
                        size="small"
                        // onClick={() => navigate(`${returnObservacionUrl}/editar/${cambio.id}`)}
                        onClick={() => navigate(`${returnObservacionUrl}/editar/${cambio.id}?origen=${origen}`)}
                        // disabled={cambio.estado?.toUpperCase() === 'IMPLEMENTADO' || cambio.estado?.toUpperCase() === 'APROBADO'}
                        disabled={['IMPLEMENTADO', 'APROBADO', 'CANCELADO'].includes(cambio.estado?.toUpperCase() ?? '')}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Grid>}
                {/* 3. Descarargar PDF */}
                {<Grid item >
                  <Tooltip title={'Descargar PDF'} placement="top">
                    <IconButton
                    color="primary"
                      onClick={async () => {
                          try {
                            const token = useAuthStore.getState().token;
                            console.log("ESTE ES EL TOKEN",token)

                              const response = await fetch(`${urlBackend}api/v1/cambios/reportejasper/jasper/cambio/${cambio.id}`, {
                              headers: { Authorization: `Token ${token}` }
                            });
                            console.log("ESTE ES EL RESPONSE", response);
                            //const BASE_URL_CAMBIOS = `${urlBackend}api/v1/cambios/`;
                            console.log(`${urlBackend}api/v1/cambios/reporte/codigo`)

                            if (!response.ok) throw new Error('Error al descargar');
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `control-cambio-${cambio.codigo}-fuente.pdf`;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                          } catch (err) {
                            console.error('Error descargando PDF:', err);
                          }
                        }}
                    >
                      <PictureAsPdfIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Grid>}
                {/* CAMBIAR DE ESTADO */}
                {<Grid item>
                  <Tooltip
                    title={
                      cambio.estado?.toUpperCase() === 'APROBADO'
                        ? 'Iniciar ejecución'
                        : cambio.estado?.toUpperCase() === 'EN_EJECUCION'
                          ? 'Registrar métricas e implementar'
                          : 'No disponible en este estado'
                    }
                    placement="top"
                  >
                    <span>
                      <IconButton
                        color="success"
                        size="small"
                        onClick={() => abrirEstadoDialog(cambio)}
                        disabled={!['APROBADO', 'EN_EJECUCION'].includes(cambio.estado?.toUpperCase() ?? '')}
                      >
                        <AccessAlarmIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Grid>}
                {/* REPROGRAMAR */}
                {cambio.estado?.toUpperCase() === 'EN_EJECUCION' && (
                <Grid item>
                    <Tooltip title="Cambiar fechas" placement="top">
                      <IconButton color="info" size="small" onClick={() => setReprogCambio(cambio)}>
                        <EditCalendarIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                {/* BOton Canelar */}
                                {cambio.estado?.toUpperCase() === 'RECHAZADO' && (
                <Grid item>
                  <Tooltip title="Cancelar cambio" placement="top">
                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => {
                         setConfirmDialog({
                          isOpen: true,
                          title: "Cancelar cambio",
                          subtitle: "¿Seguro que desea cancelar este cambio? No se podrá editar ni avanzar después.",
                          onConfirm: () => {
                            setConfirmDialogIsOpen(false);
                            cancelarMutation.mutate(cambio.id);
                          },
                        });
                      }}
                    >
                      <CancelIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          )
        }}
          

      />
      <Dialog open={estadoDialogOpen} onClose={() => setEstadoDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Registrar métricas de cumplimiento</DialogTitle>
        <DialogContent>
          {metricas.map((m, index) => (
            <Box key={index} sx={{ mb: 2, pb: 2, borderBottom: '1px solid #eee' }}>
              <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                {m.descripcion}
              </Typography>

              <FormControl>
                <RadioGroup
                  row
                  value={m.cumplido ? 'si' : 'no'}
                  onChange={(e) => {
                    const copia = [...metricas];
                    copia[index].cumplido = e.target.value === 'si';
                    setMetricas(copia);
                  }}
                >
                  <FormControlLabel value="si" control={<Radio />} label="Sí" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>

              <TextField
                fullWidth
                size="small"
                label="Observación"
                value={m.observacion}
                onChange={(e) => {
                  const copia = [...metricas];
                  copia[index].observacion = e.target.value;
                  setMetricas(copia);
                }}
                sx={{ mt: 1 }}
              />
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEstadoDialogOpen(false)}>Cancelar</Button>
          <Button variant="contained" color="primary" onClick={confirmarCambioEstado}>
            Guardar e implementar
          </Button>
        </DialogActions>
      </Dialog>
      <ModalReprogramarCambio open={!!reprogCambio} onClose={() => setReprogCambio(null)} cambio={reprogCambio} />
      <HistorialCambioModal
        open={!!historialCambio}
        onClose={() => setHistorialCambio(null)}
        cambioId={historialCambio?.id ?? ""}
        codigoCambio={historialCambio?.codigo}
      />
    </SingleTableBoxScene >
  )
  }
    return <Outlet />;
};